// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 0px;
  padding: 5px;
  display: block;
}

.price {
  font-size: 14px;
  color: black;
  margin-inline-start: 4px;
  font-family: AppFontBold, sans-serif;
}

ion-label {
  font-family: AppFont, sans-serif;
  display: block;
  font-size: 14px;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #FFFFFF;
  border-radius: 0px;
  --padding-end: 0px;
  --inner-padding-end: 2px;
  margin: 10px 0px;
}

.item-img {
  width: 50px;
  padding: 7px;
}

ion-radio::part(container) {
  border: none;
  background-size: contain;
}

ion-radio::part(mark) {
  background: none;
  transition: none;
  transform: none;
  border-radius: 0;
}

ion-radio.radio-checked::part(container) {
  background: var(--ion-color-primary);
  border-color: transparent;
}

ion-radio.radio-checked::part(mark) {
  width: 6px;
  height: 10px;
  border-width: 0px 2px 2px 0px;
  border-style: solid;
  border-color: #fff;
  transform: rotate(45deg);
}

.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.text_wrap span {
  color: #1A1A18 !important;
  font-family: AppFont, sans-serif !important;
  display: flex;
  letter-spacing: -0.5px;
}

.mehr-articles {
  width: -moz-fit-content;
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}

.ion-text-wrap {
  visibility: visible;
  transition: visibility 1.5s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-single/article-option-group-single.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EAEA,YAAA;EACA,cAAA;AAAF;;AAGA;EAEE,eAAA;EACA,YAAA;EACA,wBAAA;EACA,oCAAA;AADF;;AAIA;EACE,gCAAA;EACA,cAAA;EACA,eAAA;AADF;;AAKA;EACE,+BAAA;EACA,YAAA;EACA,WAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAIA;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAGA;EAGE,YAAA;EAEA,wBAAA;AAHF;;AASA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AANF;;AASA;EACE,oCAAA;EACA,yBAAA;AANF;;AASA;EACE,UAAA;EACA,YAAA;EAEA,6BAAA;EACA,mBAAA;EACA,kBAAA;EAEA,wBAAA;AARF;;AAUA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAPF;AASE;EACE,yBAAA;EAEA,2CAAA;EACA,aAAA;EACA,sBAAA;AARJ;;AAYA;EACE,uBAAA;EAAA,kBAAA;AATF;AAUE;EACE,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AARJ;AASI;EACE,kBAAA;AAPN;AASI;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AAPN;AAQM;EACE,cAAA;AANR;;AAWA;EACE,mBAAA;EACA,uCAAA;AARF","sourcesContent":["ion-radio-group {\n  width: 100%;\n  border-radius: 0px;\n\n  padding: 5px;\n  display: block;\n}\n\n.price {\n\n  font-size: 14px;\n  color: black;\n  margin-inline-start: 4px;\n  font-family: AppFontBold, sans-serif;\n}\n\nion-label {\n  font-family: AppFont, sans-serif;\n  display: block;\n  font-size: 14px;\n\n}\n\nion-icon {\n  color: var(--ion-color-primary);\n  height: 20px;\n  width: 20px;\n}\n\napp-tag {\n  display: inline-block;\n}\nion-item{\n  background: #FFFFFF;\n  border-radius: 0px;\n  --padding-end: 0px;\n  --inner-padding-end: 2px;\n  margin: 10px 0px;\n\n}\n.item-img {\n  width: 50px;\n  padding: 7px;\n}\nion-radio::part(container) {\n  // width: 30px;\n  // height: 30px;\n  border: none;\n  // background: url('../../../assets/losteria/add-plus.svg') no-repeat center center/ 100% 100%;\n  background-size: contain;\n  // border-radius: 8px;\n  // border: 2px solid #ddd;\n  // border-radius: 50%;\n}\n\nion-radio::part(mark) {\n  background: none;\n  transition: none;\n  transform: none;\n  border-radius: 0;\n}\n\nion-radio.radio-checked::part(container) {\n  background: var(--ion-color-primary);\n  border-color: transparent;\n}\n\nion-radio.radio-checked::part(mark) {\n  width: 6px;\n  height: 10px;\n\n  border-width: 0px 2px 2px 0px;\n  border-style: solid;\n  border-color: #fff;\n\n  transform: rotate(45deg);\n}\n.text_wrap {\n  text-align: left;\n  text-wrap: wrap;\n  white-space: normal;\n  word-break: break-word;\n  \n  span {\n    color: #1A1A18 !important;\n    \n    font-family: AppFont, sans-serif  !important;\n    display: flex;\n    letter-spacing: -0.5px ;\n\n  }\n}\n.mehr-articles {\n  width: fit-content;\n  div {\n    background: white;\n    border: 1px solid black;\n    padding: 5px 10px;\n    border-radius: 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    h3 {\n      margin-right: 20px;\n    }\n    ion-icon {\n      color: black;\n      margin-left: 15px;\n      rotate: 0deg;\n      transition: rotate 0.7s ;\n      &.rotate {\n        rotate: 180deg;\n      }\n    }\n  }\n}\n.ion-text-wrap {\n  visibility: visible;\n  transition: visibility 1.5s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
